/**
 * Styled Components - Created by cazarez on 12/03/18.
 */
import styled from 'styled-components'
import Breadcrumb from 'antd/lib/breadcrumb'
import Button from 'antd/lib/button'
import BackTop from 'antd/lib/back-top'
import Select from 'antd/lib/select'
import InputComponent from 'antd/lib/input'
import InputNumber from 'antd/lib/input-number'

import {
  RED,
  BLUE_DARK,
  DARKER_GRAY,
  GRAY,
  GRAY_DARK,
  GRAY_LIGHT,
  GRAY_HEADER,
  WHITE,
  BLUE,
  GRAY_LIGHTEST,
  BLACK_BG,
  GRAY_ANTDESIGN,
  WHITE_BG
} from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface StyledProps {
  selected?: boolean
  withBorder?: boolean
  marginLeft?: string
  disabled?: boolean
  highlight?: boolean
  secondary?: boolean
  color?: string
}

export const Container = styled.div`
  background-color: ${WHITE};
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  margin-top: var(--spacing-32);
  padding-inline: 72px;
  @media (max-width: 1024px) {
    padding-inline: 0;
  }
  @media (max-width: 767px) {
    margin-top: 0;
    user-select: none !important;
  }
`

export const BackTopStyled = styled(BackTop)`
  &.ant-back-top {
    left: 24px !important;
    right: unset !important;
    bottom: 68px !important;
  }
`

export const BackButton = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  background: #ffffffcf;
  border-radius: 90px;
  padding: 10px;
  min-width: 83px;
  font-weight: bold;
  font-family: Avenir;
  box-shadow: 0px 1px 4px -1px grey;
`

export const BackIcon = styled(Icon)`
  font-size: 30px;
  margin-right: 8px;
`

export const Content = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  max-width: 1658px;
  margin: 0 auto;
  margin-top: var(--spacing-12);
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '0px' : '36px'};
  @media (min-width: 320px) and (max-width: 767px) {
    margin-top: 0;
    display: block;
  }

  @media (min-width: 769px) {
    box-sizing: border-box;
    display: grid;
    gap: 64px;
    grid-template-columns: minmax(0, 1fr) 440px;
    justify-content: center;
    width: 100%;
  }
`

export const ComingSoonLayer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 7;
  font-family: Avenir;
  color: white;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2.5px);
  background-color: #000000b0;
`

export const ComingSoonLabel = styled.div`
  margin-top: 14px;
  font-size: 38px;
  font-weight: bold;
  filter: drop-shadow(2px 4px 6px #505050);
`

export const GetNotified = styled.div`
  margin-top: 24px;
  background: #47b97a;
  padding: 6px 8px;
  border-radius: 5px;
  max-width: 200px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  position: relative;
  box-shadow: 1px 2px 3px -1px #545454;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: white;
    color: #47b97a;
  }
`

export const NotifIcon = styled(Icon)`
  position: absolute;
  right: 19px;
  top: 8px;
  color: #fff8e8;
`

export const SizeChart = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  margin: 0 0 30px 0;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    max-width: 100%;
    object-fit: contain;
    margin: 0 0 22px 0;
    padding-right: 22px;
    height: 54px;
    width: 100%;
  }
`

export const SizeChartCustom = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 926px) {
    margin-top: 24px;
    margin-bottom: 16px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
    margin-top: unset;
    margin-bottom: unset;
  }
`

export const SizeChartCustomMobile = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: contain;
  display: none;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const MobileFlex = styled.div`
  display: none;
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const ImagePreview = styled.div`
  width: 60%;
  position: relative;
  .swipeImg {
    max-height: 554px;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    padding: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    width: 100%;
  }

  @media (min-width: 769px) {
    align-self: start;
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
    justify-self: stretch;
    max-width: none;
    width: 100%;
    .swipeImg {
      overflow-clip-margin: unset;
    }
  }

  @media (min-width: 769px) {
    &[data-media-view='carousel'] {
      height: 1226px;
    }
  }
  
`

export const ProductData = styled.div`
  box-sizing: border-box;
  padding: 18px;
  padding-top: 5px; /* images are 5px apart from the header */
  width: 40%;
  padding-bottom: 0;
  @media (min-width: 769px) {
    align-self: flex-start;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    justify-self: stretch;
    padding: 0;
    position: sticky;
    top: 108px;
    width: 100%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    position: static;
    width: 100%;
    padding: 14px 24px;
  }
  .ratingsContainer {
    margin: 10px 0 0;
  }
  #addOnHeaderActionsContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    #headerActions {
      display: none;
      @media (min-width: 768px) {
        display: flex;
      }
    }
  }
  #priceLbl {
    margin-bottom: 4px;
    color: var(--neutral-secondary);
    font: 400 14px/22px var(--font-inter);
    b {
      color: var(--neutral-darkest);
      font-weight: 600;
    }
  }
  #pricingFaq {
    margin-top: var(--spacing-12);
    color: var(--neutral-secondary);
    font: 400 13px/20px var(--font-inter);
    text-decoration: underline;
    &:hover {
      cursor: pointer;
    }
  }
`

export const ProductDesktopSummary = styled.div`
  display: block;
  margin-block: 0 var(--spacing-24);
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
  &[data-inline="true"] {
    margin-top: var(--spacing-8);
  }
  #addOnHeaderActionsContainer:has(> :first-child:empty) + & {
    margin-top: 0px;
  }
`

export const ProductMobileSummary = styled.div`
  display: none;

  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    flex-direction: column;
  }
  
  [data-appearance='prod-v2-mobile'] {
    display: flex;
    #reviewsCount {
      font: 400 13px/12px var(--font-inter);
      margin-top: 2px;
      margin-left: 8px;
    }
  }
`

export const ProductDataHeader = styled.div`
  margin-bottom: 20px;
`

export const ProductMetaRowMobile = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block: 32px;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-block: var(--spacing-8) var(--spacing-24);
    border-bottom: 1px solid var(--neutral-border-light);
  }
`

export const ProductMetaRow = styled.div`
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;

  .ratingsContainer {
    margin: 0;
  }

  [data-appearance='prod-v2-desktop'] {
    flex-flow: column;
  }

  [data-appearance='prod-v2-desktop'] > div#reviewsCount {
    color: var(--neutral-secondary);
    font: 400 13px/18px var(--font-inter);
    margin-left: 0;
    height: fit-content;
    width: auto;
  }
`
export const Title = styled.div`
  color: var(--neutral-darkest);
  font: normal 700 40px/42px var(--font-barlow-semi-condensed);
  letter-spacing: 0.44px;
  text-transform: capitalize;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 40px;
    white-space: nowrap;
    line-height: normal;
  }
`

export const Subtitle = styled.div`
  color: var(--neutral-secondary);
  font: 500 14px/20px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;

  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 12px;
  }
`

export const TitleSubtitleContainer = styled.div``

export const StyledLink = styled.a`
  @media (min-width: 320px) and (max-width: 480px) {
    align-self: center;
  }
`

export const ColorButtons = styled.div`
  display: flex;
  flex-flow: column;
  position: absolute;
  left: 25px;
  top: 20px;
  z-index: 3;
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) 2s both;
  @keyframes fade-in-left {
    0% {
      transform: translateX(-7px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const ToneButton = styled.img`
  object-fit: contain;
  height: 27px;
  width: 27px;
  background: ${({ selected }: StyledProps) =>
    selected ? GRAY_LIGHTEST : WHITE};
  padding: 5px;
  margin-bottom: 8px;
  border-radius: 25px;
  box-shadow: ${({ selected }: StyledProps) =>
    selected ? 'unset' : `0px 2px 3px -1px ${GRAY_DARK}`};
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const InlineContainer = styled.div`
  position: relative;
  width: 100%;
`

export const StyledBreadCrumb = styled(Breadcrumb)`
  border: 1px solid ${GRAY_LIGHT};
  padding: 10px 0 10px 49px;
  background-color: ${WHITE};
`

export const StyledInputNumber = styled(InputNumber)`
  border-radius: 0;
  height: 40px;
  width: 138px;
  border: 1px solid ${GRAY};
`

export const AvailablePrices = styled.div`
  display: flex;
  flex-flow: column;
  align-self: stretch;
  align-items: center;
  &:first-child > div > div:first-child {
    font-weight: normal;
  }
`

export const PricesRow = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  border: 1px solid var(--neutral-border-light);
  padding: var(--spacing-16);
  overflow: hidden;
  [data-appearance='prod-v2'] {
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    color: var(--neutral-secondary);
    font-family: var(--font-barlow);
    #bottomLabels {
      display: flex;
      flex-direction: column;
      justify-content: center;
      #marginLabel {
        margin-top: var(--spacing-4);
        background: unset !important;
        color: var(--neutral-muted);
        text-align: center;
        font: 500 11px/16px var(--font-barlow);
        letter-spacing: 0.158px;
      }
    }
    #quantityLabel {
      font: 500 11px/14px var(--font-barlow);
      margin-top: var(--spacing-4);
    }
    #priceLabel {
      color: var(--neutral-darkest);
      font: 600 20px/26px var(--font-barlow);
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-between;
    margin-block: var(--spacing-24);
  }
  ${({ third }: DivProps) => third ? `
    & > div > div {
      display: none;
      :first-child {
        display: block;
      }
      > div > div:last-child {
        display: none;
      }
    }
    #vnl {
      font-weight: 600;
      font-size: 11px;
      font-style: italic;
    }
  ` : ''}
`

export const PriceOnlyDesktop = styled.div`
display: none;
@media (min-width: 768px) {
  display: flex;
  position: relative;
  width: 100%;
  max-width: 100%;
  margin-top: calc(var(--spacing-16) - 2px);
  overflow-x: auto;
  > * {
    flex: 0 0 auto;
  }
  [data-appearance='prod-v2'] {
    > * {
      padding-inline: 10px;
    }
  }
  > *:not(:last-child) [data-appearance='prod-v2'] {
    border-right: 1px solid var(--neutral-border-light);
  }
}
`

export const PriceOnlyMobile = styled.div`
display: none;
@media (min-width: 320px) and (max-width: 480px) {
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  column-gap: 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  -webkit-mask-image: none;
  mask-image: none;

  /* 2. Attach the CSS Scroll-Driven Animation */
  /* This ties the animation's progress directly to the horizontal scrollbar */
  animation: overflow-mask linear both;
  animation-timeline: scroll(inline self);
  @keyframes overflow-mask {
    /* From 0% (start) to 99% scrolled: Show the 80px fade out */
    0%, 99% {
      -webkit-mask-image: linear-gradient(to right, black calc(100% - 80px), transparent 100%);
      mask-image: linear-gradient(to right, black calc(100% - 80px), transparent 100%);
    }
    
    /* At exactly 100% scrolled: Make the mask solid so the last item is fully visible */
    100% {
      -webkit-mask-image: linear-gradient(to right, black 100%, transparent 100%);
      mask-image: linear-gradient(to right, black 100%, transparent 100%);
    }
  }
  
  &::-webkit-scrollbar {
    display: none;
  }
  > * {
    flex: 0 0 auto;
  }
}
`

export const Description = styled.div`
  color: var(--neutral-body);
  font: 400 14px/22px var(--font-inter);
  letter-spacing: 0;
  margin-top: var(--spacing-24);
  width: 100%;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: 0;
  }
`

export const DescriptionRich = styled.div`
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  width: 100%;

  .rdw-editor-wrapper,
  .rdw-editor-main,
  .DraftEditor-root,
  .DraftEditor-editorContainer,
  .public-DraftEditor-content {
    color: inherit;
    font: inherit;
    letter-spacing: inherit;
  }

  .rdw-editor-main {
    height: auto;
    overflow: visible;
  }

  .public-DraftEditor-content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
  }

  .public-DraftEditor-content span {
    font-family: Inter, sans-serif;
    color: #737370 !important;
    font-size: 14px !important;
    letter-spacing: 0;
    line-height: 22px;
  }

  .public-DraftEditor-content .public-DraftStyleDefault-block {
    margin: 0;
  }

  .public-DraftEditor-content .public-DraftStyleDefault-ul,
  .public-DraftEditor-content .public-DraftStyleDefault-ol {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8) !important;
    margin-top: var(--spacing-24) !important;
  }

  b,
  strong {
    font-weight: 600 !important;
  }
`

export const ProductDescription = styled.div`
`

export const DescriptionTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 14px;
  text-align: center;
  background: #EFF2F4;
  padding: 6px;
`

export const DescriptionSection = styled.div`
  max-width: 1282px;
  margin: 0 auto;
  padding: 0 48px;
  @media (max-width: 698px) {
    padding: 0px 18px;
    margin-top: 32px;
  }
`

export const ButtonsRow = styled.div`
  display: flex;
  margin-left: var(--spacing-12);
  flex-basis: 80%;
  [data-appearance='prod-v2'] {
    width: 100%;
  }
  .ant-btn {
    color: ${({ disabled }: StyledProps) => disabled ? GRAY : WHITE} !important;
    border-color: ${({ disabled }: StyledProps) => disabled ? GRAY_HEADER : '#2b2b2c'} !important;
    background-color: ${({ disabled }: StyledProps) => disabled ? GRAY_HEADER : '#2b2b2c'} !important;
    width: 100% !important;
    height: var(--spacing-42) !important;
    color: var(--neutral-muted);
    font: 600 12px/20px var(--font-barlow);
    letter-spacing: 1.12px;
    text-transform: uppercase;
    &:hover {
      cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
    }
  }
  #CartLabel {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-12);
  }
  @media (max-width: 698px) {
    width: 100%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    flex-flow: column;
  }
  &:hover {
    cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
  }
`

export const StyledButtonWrapper = styled.div`
  .ant-btn-primary  {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE_DARK};
    border-color: ${BLUE_DARK};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 18px 0 0;
  }
  margin-left: ${({ marginLeft }: StyledProps) => marginLeft || '0px'};
`
export const SlideImage = styled.img`
  width: 100%;
`

export const SlideVideo = styled.video`
  width: 100%;
`

export const SlideImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`

export const Separator = styled.div`
  text-align: center;
  margin: 48px 10% 28px 10%;
  padding-bottom: 8px;
  border-bottom: 1px solid ${GRAY_LIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.93px;
  line-height: 18px;
`

export const TitleName = styled.div`
  margin-right: 8px;
`

export const StyledButton = styled.div`
  display: flex;
  height: 44px;
  padding: 7px var(--spacing-16);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-12);
  background: var(--neutral-darkest);
  align-self: stretch;
  color: var(--neutral-white);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.20) 0%,
      rgba(255, 255, 255, 0.20) 100%
    ), var(--neutral-darkest);
  }
`

export const CustomizeButton = styled.a`
  height: 50px;
  width: 256px;
  border: 1px solid ${BLUE};
  border-radius: 2px;
  cursor: pointer;
  font-weight: 600;
  background-color: ${WHITE};
  box-shadow: 1px 2px 4px -1px #9d9d9d;
  color: ${BLUE};
  font-size: 16px;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  &:hover {
    background: ${BLUE};
    color: ${WHITE};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const ColorWheel = styled.img`
  width: 20px;
  margin-right: 12px;
`

export const MobileButtonWrapper = styled.div`
  display: none;
  width: 100%;
  margin-top: var(--spacing-32);
  @media (min-width: 320px) and (max-width: 480px) {
    display: block;
  }
`

export const MobileButton = styled.div`
  display: none;
  height: 50px;
  width: 100%;
  margin-bottom: 16px;
  border: 1px solid #2b2b2c;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  background-color: #2b2b2c;
  box-shadow: 1px 1px 4px -1px #9d9d9d;
  color: white;
  font-size: 16px;
  justify-content: center;
  align-items: center;

  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
export const CompareButton = styled(Button)`
  display: flex;
  height: 40px;
  padding: var(--spacing-8) var(--spacing-16);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-8);
  border: var(--border-regular) solid var(--neutral-muted);
  background: var(--neutral-white);
  color: var(--neutral-body);
  font: 700 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  border-radius: 0;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
    border: var(--border-regular) solid var(--neutral-darkest);
    color: var(--neutral-darkest);
  }
  &:focus {
    color: #3998c4;
    border-color: #3998c4;
  }
  @media (max-width: 698px) {
    width: 100%;
  }
`

export const BuyNowOptions = styled.div`
  margin-bottom: 40px;
  ${({ secondary }: DivProps) => secondary ? `
    @media (max-width: 698px) {
      display: flex;
      flex-wrap: wrap;
      column-gap: 28px;
      margin-bottom: 0;
      .sectionRow {
        margin-bottom: 6px;
      }
    }
    .sectionTitle {
      margin-bottom: 8px;
    }
  ` : ''}
`

export const DealerTitle = styled.div`
  margin-top: 8px;
  margin-bottom: -12px;
  color: ${RED};
`

export const GenderRow = styled.div`
  display: flex;
  margin-bottom: 20px;
`
export const SectionTitle = styled.div`
  margin-bottom: 0;
  color: var(--neutral-body);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
`
export const SectionTitleContainer = styled.div`
  display: flex;
  &[data-appearance='prod-v2'] {
    align-items: center;
    justify-content: space-between;
    width: 100%;
    & > .sectionTitle {
      color: #0A0A09;
      font: 600 12px/18px var(--font-barlow);
      letter-spacing: 1.12px;
      text-transform: uppercase;
    }
  }
`

interface ButtonProps {
  selected: boolean
  large?: boolean
  oneSize?: boolean
  range?: boolean
}

export const SectionButton = styled.div`
  align-content: center;
  background-color: ${({ selected }: ButtonProps) => selected ? BLACK_BG : WHITE};
  color: ${({ selected }: ButtonProps) => selected ? WHITE : 'rgba(0, 0, 0, 0.65)'};
  border: ${({ selected }: ButtonProps) =>
    selected ? `0.5px solid ${BLACK_BG}` : '0.5px solid #dcdcdc'};
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  display: flex;
  margin-right: 14px;
  padding: ${({ range }: ButtonProps) => range ? '8px 16px' : '10px 22px'};
  white-space: nowrap;
  transition: all .25s;
  opacity: ${({ disabled }: StyledProps) => disabled ? '0.6' : '1'};
  margin-bottom: ${({ range }: ButtonProps) => (range ? '8px' : 'unset')};
  justify-content: center;
  width: ${({ large, oneSize }: ButtonProps) => {
    let width = oneSize ? 'auto' : 'fit-content'
    if (large) {
      width = '139px'
    }
    return width
  }};
  &[data-button-appearance='gender'] {
    display: flex;
    flex-basis: 50%;
    margin-right: 0;
    width: unset !important;
    padding: var(--spacing-8) var(--spacing-16);
    justify-content: center;
    align-items: center;
    border: var(--border-regular) solid var(--neutral-border-med);
    background: var(--neutral-white);
    border-radius: 0;
    color: var(--neutral-secondary);
    font: 600 14px/20px var(--font-barlow);
    letter-spacing: 1.12px;
    text-transform: capitalize;
    box-shadow: none;
    ${({ selected }: ButtonProps) => selected ? `
      border: var(--border-regular) solid var(--neutral-darkest);
      background: var(--neutral-darkest);
      color: var(--neutral-white);
    ` : ''}
  }
  &[data-button-appearance='size'] {
    margin-right: 0;
    padding: var(--spacing-12) var(--spacing-24);
    border: var(--border-regular) solid var(--neutral-border-med);
    border-radius: 0;
    color: var(--neutral-darkest);
    text-align: center;
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1.12px;
    text-transform: uppercase;
    width: 80px !important;
    height: calc(var(--spacing-32) + var(--spacing-6));
    box-shadow: none;
    ${({ selected }: ButtonProps) => selected ? `
      border: var(--border-regular) solid var(--neutral-darkest);
      background: var(--neutral-darkest);
      color: var(--neutral-white);
    ` : ''}
  }

  &:hover {
    cursor: ${({ disabled }: StyledProps) => disabled ? 'not-allowed' : 'pointer'};
  }

  @media (min-width: 320px) and (max-width: 768px) {
    margin-bottom: 15px;
    border-radius: 0;
    box-shadow: none;
    border: 0.5px solid ${BLACK_BG};
  }
  ${({ highlight }: StyledProps) => highlight ? `
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }

      70% {
        filter: drop-shadow(0 0 15px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        background-color: #white !important;
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        background-color: #fff3f3 !important;
      }
    }
    background-color: #fff3f3 !important;
  ` : ''}
`

export const SectionRow = styled.div`
  margin-bottom: 18px;
  &[data-section="colors"] {
    margin-top: var(--spacing-24);
  }
  @media (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
`
export const SectionButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  &[data-appearance='prod-v2'] {
    & > div:not(:last-child) {
      margin-right: 6px;
    }
  }
  @media (min-width: 320px) and (max-width: 768px) {
    justify-content: start;
  }

  @media (min-width: 769px) and (max-width: 1023px) {
    flex-wrap: wrap;
  }
`
export const SizeRowTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-8);
`

export const GetFittedLabel = styled.div`
  height: 22px;
  color: ${RED};
  font-size: 16px;
  line-height: 22px;
  &:hover {
    cursor: pointer;
  }
`

export const QuestionSpan = styled.span`
  margin-left: 8px;
  height: 16px;
  width: 16px;
  color: ${GRAY_DARK};
  font: 700 10px var(--font-barlow);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #EDEDEB;
  &:hover {
    cursor: pointer;
  }
`
export const AddToCartRow = styled.div`
  display: flex;
`

export const AddToCartButton = styled(Button)`
  height: 40px;
  width: 138.23px;
  border-radius: 2px;
  background-color: ${BLUE};
  color: ${WHITE};
  margin-left: 26px;

  &:hover {
    background-color: ${BLUE};
    color: ${WHITE};
    border-color: ${BLUE};
  }
`
export const RelatedProductsContainer = styled.div`
  margin-bottom: 80px;
  padding: 0px 32px;
`
export const ReviewsHeader = styled.div`
  align-items: center;
  background-color: ${GRAY_HEADER};
  color: ${GRAY_DARK};
  display: flex;
  font-size: 18px;
  font-weight: 600;
  height: 38px;
  letter-spacing: 0.23px;
  line-height: 25px;
  margin-bottom: 15px;
  padding-left: 32px;
`

export const YotpoImageSlider = styled.div``

export const Downloadtemplate = styled.div`
  height: 19px;
  color: ${DARKER_GRAY};
  font-size: 14px;
  line-height: 19px;
  margin-left: 10px;
`

export const DownloadTemplateContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-right: 20px;
`
export const DownloadAnchor = styled.a`
  display: flex;
`

export const DownloadImg = styled.img`
  &:hover {
    cursor: pointer;
  }
`

export const ColorOption = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 38px;
  height: 38px;
  background: ${({ color }: StyledProps) => color ? color : 'transparent'};
  border: ${({ selected, withBorder }: StyledProps) =>
    selected ? 'var(--border-regular) solid var(--neutral-darkest)'
    : withBorder ? 
      'var(--border-regular) solid var(--neutral-muted)'
      : 'none'
  };
  outline: ${({ selected }: StyledProps) => selected ? `var(--border-regular) solid var(--neutral-darkest)` : 'none'};
  outline-offset: ${({ selected }: StyledProps) => selected ? `var(--border-regular)` : 'none'};
  &:hover {
    cursor: pointer;
  }
  &[data-disabled='true'] {
    &:hover {
      cursor: not-allowed;
    }
    background:
      linear-gradient(
        135deg,
        transparent calc(50% - 1.5px),
        #444 calc(50% - 1.5px),
        #444 calc(50% + 1.5px),
        transparent calc(50% + 1.5px)
      ),
      ${({ color }: StyledProps) => color ? color : 'transparent'};
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  & > .icon-wrapper {
    display: ${({ selected }: StyledProps) => selected ? 'inline-flex' : 'none'};
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: -4px;
    right: -4px;
    width: 16px; 
    height: 16px;
    background: var(--series-pro);
    border: var(--border-regular) solid var(--neutral-darkest);
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;

    .anticon {
      display: flex;
      font-size: 14px;
      line-height: 1;
      svg {
        fill: var(--neutral-darkest, #0A0A09) !important;
        transform: scale(1.25); 
      }
      svg path,
      svg circle,
      svg rect {
        fill: inherit !important;
      }
    }
  }
`

export const DisabledText = styled.div`
  position: absolute;
  z-index: 3;
  bottom: -16px;
  width: 100%;
  color: #d70000;
  display: flex;
  justify-content: center;
  font-size: 11px;
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 8px;
  }
`

interface DivProps {
  secondary?: boolean
  third?: boolean
  highlight?: boolean,
  selected?: boolean,
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 12px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : ''};
  @media (min-width: 320px) and (max-width: 480px) {
    display: ${({ selected }: DivProps) => selected ? 'block' : 'none'};
    position: absolute;
    bottom: -18px;
    color: black;
  }
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  box-shadow: 1px 2px 2px 0px #e1e1e1;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
  ${({ highlight }: DivProps) => highlight ? `
    animation: blink-1 1.25s 2 ease-in-out;
    @keyframes blink-1 {
      0% {
        box-shadow: 0 0 0 0 #ff6a6a;
      }
      100% {
        box-shadow: 0 0 0 13px #fff8f8b8;
      }
    }
  ` : ``}
  @media (min-width: 320px) and (max-width: 480px) {
    outline: ${({ selected }: StyledProps) => selected ? '1px solid' : 'none'};
    border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? '2px solid white'
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
  }
`

export const ColorWrapper = styled.div`
  display: flex;
  > div:not(:last-child) {
    margin-right: calc(var(--spacing-4) + 2px);
  }
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

export const layoutStyle = {
  backgroundColor: WHITE_BG,
}

export const ActionButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 25px;

  .ant-btn {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    flex-flow: column;
  }
  @media (min-width: 480px) and (max-width: 940px) {
    display: block;
  }
`

export const DesktopPrimaryActionRow = styled.div`
  margin-top: 24px;
  width: 100%;

  > div {
    width: 100%;

    > div {
      width: 100%;
      border-radius: 0;
      box-shadow: none;
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
`

export const DesktopSecondaryActionsRow = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 12px;
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
`

export const MobileButtonTemplate = styled.div`
  display: none;
  align-items: center;
  gap: var(--spacing-8);
  color: var(--neutral-secondary);
  font: 400 13px/20px var(--font-inter);
  text-decoration: underline;
  text-underline-offset: 14.5%;
  text-underline-position: from-font;
  cursor: pointer;
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
  }
`

export const ButtonTemplate = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-8);
  color: var(--neutral-secondary);
  font: 400 13px/20px var(--font-inter);
  text-decoration: underline;
  text-underline-offset: 14.5%;
  text-underline-position: from-font;
  cursor: pointer;
  &:hover {
    color: var(--neutral-darkest);
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: none;
  }
  @media (min-width: 480px) and (max-width: 940px) {
    height: 40px;
    line-height: 40px;
  }
`

export const RightArrow = styled(Icon)`
  stroke: white;
  stroke-width: 30px;
  font-size: 17px;
`

export const Download = styled(Icon)`
  stroke: var(--neutral-secondary);
  stroke-width: 30px;
  font-size: 15px;
`

export const QuantitySection = styled.div`
  flex-basis: 25%;
`

export const QuantityDiv = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${GRAY_ANTDESIGN};
  width: fit-content;
  border-radius: 0;
  font-size: 18px;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media(max-width: 698px) {
    margin: 0 auto;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    border: 1px solid #b4b4b4;
    margin: 0;
  }
`

export const MinusButton = styled.div`
  width: 40px;
  text-align: center;
  transition: all .25s;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    background: #f7f7f7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 38px;
    font-size: 24px;
  }
`

export const QuantityInput = styled.input`
  border: none;
  text-align: center;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid ${GRAY_ANTDESIGN};
  border-right: 1px solid ${GRAY_ANTDESIGN};
  font-size: 15px;
  padding: 3px 0;
  font-weight: bold;
  font-family: Avenir;
  -moz-appearance: textfield !important;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    width: 40px;
    border-left: 1px solid ${BLACK_BG};
    border-right: 1px solid ${BLACK_BG};
    font-size: 18px;
  }
`

export const PlusButton = styled.div`
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .25s;
  height: 42px;
  padding-top: 1px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    background: #f7f7f7;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 38px;
    font-size: 24px;
  }
`

export const RightButtons = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 3px;
    width: 100%;
  }
`

export const TopButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  row-gap: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 698px) {
    flex-flow: column-reverse;
    align-items: flex-end;
    margin-top: 4px;
    row-gap: 6px;
    width: 100%;
  }
`

type SelectType = {
  selectWidth?: string
  highlightFields?: boolean
}

export const UpgradesSection = styled.div``

export const UpgradesDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const UpgradeInput = styled.div`
  max-width: 192px;
  width: 100%;
  margin-right: 28px;
  margin-bottom: 20px;
  @media (max-width: 698px) {
    max-width: 158px;
    width: 100%;
    margin-right: 18px;
  }
`

export const UpgradeTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const StyledSelect = styled(Select)`
  width: 100%;
  & .ant-select-selection {
    border-color: ${({ highlightFields }: SelectType) =>
    highlightFields ? RED : GRAY_ANTDESIGN};
    transition: all .25s;
  }
  transition: all .25s;
  ${({ highlightFields }: SelectType) => highlightFields ? `
    .ant-select-selection {
      background: #fff3f3;
    }
    animation: pulse 1s 0.5s 2;
    @keyframes pulse {
      0% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }

      70% {
        filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0));
        transform: scale(1.05);
        .ant-select-selection {
          background: #white !important;
        }
      }

      100% {
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
        transform: scale(1);
        .ant-select-selection {
          background: #fff3f3 !important;
        }
      }
    }
  ` : ''}
`

export const QuestionSpanUpgrade = styled.span`
  color: #5f6062;
  font: 500 14px/0 Avenir;
  margin-left: 8px;
  border: 1px solid #c1c1c1;
  background: #f8f8f8;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 22px;
  height: 22px;

  &::after {
    content: '?';
  }
  &:hover {
    cursor: pointer;
  }
`

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
  #prdTitle {
    font-weight: bold;
    font-size: 22px;
    margin-block: -14px 38px;
  }
  #popularLbl {
    margin: 0 auto;
    margin-block: -24px 4px;
    background: #48b548;
    width: fit-content;
    color: white;
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 11px;
  }
  .optionTitle {
    font-size: 20px;
    font-weight: bold;
  }
  .subtitle {
    font-weight: 500;
    margin-bottom: 12px;
  }
  #leftCard {
    max-width: 348px;
    border-right: 1px solid darkgray;
    padding-right: 32px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  #rightCard {
    max-width: 368px;
    padding-left: 32px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  p {
    flex: 1;
  }
  .btnAction {
    background: cornflowerblue;
    color: white;
    border-radius: 25px;
    padding: 4px 20px;
    margin-block: 12px 4px;
    box-shadow: 0px 1px 2px 1px #e5e5e5;
    transition: opacity .25s;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  #cardsPrd {
    display: flex;
    max-width: 768px;
    text-align: center;
  }
  .imagePrd {
    max-width: 118px;
  }
  #prcBlocks {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 4px 12px 12px 22px;
    font-family: Avenir:
  }
  .prcBlck {
    width: 80px;
    color: black;
    line-height: 1;
    &:first-child {
      color: gray;
      .prcLbl {
        display: none;
      }
    }
  }
  .prcVal {
    font-weight: bold;
    font-size: 16px;
  }
  .prcLbl {
    font-size: 11px;
    color: gray;
  }
  #bttmPrcLbl {
    text-align: left;
    width: 100%;
    padding: 10px 4px 14px 22px;
  }
  #contc {
    text-align: right;
    width: 100%;
    padding: 0 22px 14px;
    a {
      color: cornflowerblue;
    }
  }
  @media (max-width: 698px) {
    #prcBlocks {
      padding: 4px 4px 10px 8px;
    }
    .prcVal {
      font-size: 12px;
    }
    .prcLbl {
      font-size: 9px;
    }
    .bttmPrcLbl, #contc {
      font-size: 13px;
    }
    #leftCard {
      padding-right: 15px;
      margin-left: -32px;
    }
  }
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  width: 100%;
  @media (max-width: 768px) {
    max-width: 886px;
    margin-top: 0px;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const MSRPDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  h2 {
    color: var(--neutral-darkest);
    font: 600 32px/38px var(--font-barlow-semi-condensed);
    margin-bottom: 0;
  }
  @media (max-width: 480px) {
    margin-top: 2px;
  }
`

export const MSRPLabel = styled.div`
  color: var(--neutral-secondary);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
`

export const DealerDiv = styled.div`
  display: flex;
  color: var(--neutral-muted);
  font: 400 13px/17px var(--font-inter);
  margin-block: var(--spacing-4) var(--spacing-16); 
  span {
    display: inline-block;
    margin-left: var(--spacing-4);
  }
`

export const NotAvailable = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  position: fixed;
  width: 100%;
  background: #000000c4;
  color: white;
  z-index: 1;
  justify-content: center;
  top: 0;
  left: 0;
  height: 100%;
`

export const StyledInputReminder = styled(InputComponent)`
  border-radius: 25px;
  margin-right: 14px;
  border: none;
  background: #f4f4f4;
  width: 100%;
  height: 32px;
  padding: 6px 16px;
  margin-top: 4px;
  margin-bottom: 16px;
  border-radius: 25px;
  width: 100%;
`

export const Label = styled.div`
  height: 20px;
  margin-left: 12px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const SaveButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  border: none;
  box-shadow: 1px 2px 3px -1px #aaaaaa;
  color: ${WHITE};
  background: ${BLUE};
  margin-top: 10px;
  @media (max-width: 767px) {
    margin-top: 28px;
    width: 100%;
    margin-right: 0;
    height: 50px;
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  box-shadow: 1px 2px 4px -1px #d4d4d4;
  margin-top: 12px;
  border: 1px solid #ececec;
`

export const AssistanceDiv = styled.div`
  display: flex;
  align-items: center;
  a {
    margin-right: var(--spacing-4);
    color: var(--accent-green);
    font: 600 14px/22px var(--font-inter);
    text-decoration: underline;
    text-underline-offset: 20%;
    text-underline-position: from-font;
  }
  svg {
    color: var(--accent-green);
    width: var(--spacing-16);
    height: var(--spacing-16);
    flex-shrink: 0;
    aspect-ratio: 1/1;
  }
`

export const GridImages = styled.div`
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
`

export const GridMediaTile = styled.button`
  appearance: none;
  background: var(--neutral-border-light);
  border: 0;
  cursor: pointer;
  display: block;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;

  &::after {
    background: rgba(255, 255, 255, 0.12);
    content: '';
    inset: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transition: opacity 0.2s ease;
  }

  &:hover::after {
    opacity: 1;
  }

  &[data-media-kind='video'] {
    background: var(--neutral-darkest);
  }

  img,
  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const ProductMediaCarousel = styled.div`
  align-items: center;
  background: var(--neutral-white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 560px;
  position: relative;
  width: 100%;

  @media (min-width: 320px) and (max-width: 480px) {
    min-height: auto;
  }
`

export const CarouselMediaFrame = styled.div`
  width: 100%;
  height: 100%;

  .react-swipeable-view-container {
    align-items: stretch;
    height: 100%;
  }

  .react-swipeable-view-container > div {
    height: 100%;
  }
`

export const CarouselMediaItem = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const CarouselMediaImage = styled.img`
  aspect-ratio: 3 / 4;
  display: block;
  object-fit: cover;
  pointer-events: none;
  width: 100%;
`

export const CarouselMediaVideo = styled.video`
  aspect-ratio: 3 / 4;
  display: block;
  object-fit: cover;
  pointer-events: none;
  width: 100%;
`

export const CarouselArrow = styled.button`
  align-items: center;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid var(--neutral-border-med);
  border-radius: 50%;
  color: var(--neutral-darkest);
  cursor: pointer;
  display: flex;
  height: var(--spacing-42);
  justify-content: center;
  position: absolute;
  top: 50%;
  width: var(--spacing-42);
  z-index: 2;

  .anticon {
    align-items: center;
    display: flex;
    font-size: 16px;
    justify-content: center;
  }
    
  @media (min-width: 320px) and (max-width: 480px) {
    height: var(--spacing-32);
    width: var(--spacing-32);
  }

  &[data-direction='previous'] {
    left: var(--spacing-16);
  }

  &[data-direction='next'] {
    right: var(--spacing-16);
  }
`

export const CarouselCounter = styled.div`
  background: var(--neutral-white);
  border: 1px solid var(--neutral-border-light);
  border-radius: 50% / 100%;
  bottom: var(--spacing-24);
  color: var(--neutral-darkest);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  padding: 4px 12px;
  position: absolute;
  text-transform: uppercase;
  z-index: 2;

  @media (min-width: 320px) and (max-width: 480px) {
    bottom: auto;
    margin: var(--spacing-12) auto 0;
    position: relative;
    transform: none;
    left: auto;
  }
`

export const CarouselGridButton = styled.button`
  align-items: center;
  background: var(--neutral-white);
  border: unset;
  color: var(--neutral-darkest);
  cursor: pointer;
  display: flex;
  font: 600 12px/18px var(--font-barlow);
  gap: var(--spacing-12);
  letter-spacing: 1px;
  padding: var(--spacing-12) var(--spacing-14);
  position: absolute;
  right: var(--spacing-16);
  text-transform: uppercase;
  top: var(--spacing-16);
  z-index: 3;

  .anticon {
    color: var(--neutral-darkest);
    font-size: 14px;
  }
  &:hover {
    background: var(--neutral-border-light);
  }
`

export const AddOnContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-24);
  border-bottom: 1px solid var(--neutral-border-light);
  padding-bottom: var(--spacing-24);
  margin-bottom: var(--spacing-24);
  &:empty {
    display: none;
  }
`

export const AddOn = styled.div`
  display: inline-flex;
  height: 24px;
  padding: var(--spacing-8);
  justify-content: center;
  align-items: center;
  color: var(--accent-green);
  background: var(--accent-trans-lime);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
`

export const SerieBadge = styled.div`
  display: inline-flex;
  height: 30px;
  padding: var(--spacing-8) var(--spacing-12);
  margin-bottom: var(--spacing-24);
  justify-content: center;
  align-items: center;
  background: var(--neutral-lightest-block);
  color: var(--neutral-secondary);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  &:not([data-serie]) {
    display: none;
  }
  &[data-serie="0"] {
    color: var(--series-xpo);
  }
  &[data-serie="1"] {
    color: var(--series-pro);
  }
  &[data-serie="2"] {
    color: var(--series-club);
  }
  &[data-size="small"] {
    height: 24px;
  }
  &[data-inline="true"] {
    color: var(--neutral-secondary);
    background: transparent !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    background: transparent;
    color: var(--neutral-secondary) !important;
    padding-left: 0;
    margin-bottom: 0;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductDetail/styledComponents.tsx